import { hasEnoughSpace } from '@player/utils/hasEnoughSpace';
import { calculateUiZoom } from '@player/utils/uiZoom';
/**
 * VideoPlayer store actions
 */
export const actions = (set, _get) => ({
    setUserPaused: (isUserPaused) => set({ isUserPaused }, false, 'setUserPaused'),
    setUserMuted: (isUserMuted) => set({ isUserMuted }, false, 'setUserMuted'),
    setVisibility: (isVisible) => set({ isVisible }, false, 'setVisibility'),
    setLayout: (layout) => {
        set({ layout }, false, 'setLayout');
    },
    setLayoutByUser: (layout) => {
        set({ layout, isLayoutChangedByUser: true }, false, 'setLayoutByUser');
    },
    setOpenReasonByUser: (openReason) => {
        set({ openReason }, false, 'setOpenReasonByUser');
    },
    setLayoutSize: (layoutSize) => {
        const { width, height } = layoutSize;
        set({
            layoutSize,
            // TODO(ZE-400): Remove usage of isDesktop in favor of usePlayerLayout
            isDesktop: hasEnoughSpace(width, height),
            uiZoom: calculateUiZoom(width, height),
        }, false, 'setContainerSize');
    },
    setInitTrackingHasBeenCalled: () => set({ initTrackingHasBeenCalled: true }, false, 'setInitTrackingHasBeenCalled'),
    /**
     * Lock navigation to prevent user navigate away from current video by disabling some navigation UI. Used when Ads are playing
     * or when livestream is active.
     */
    lockNavigation: () => set({ navigationLocked: true }, false, 'lockNavigation'),
    unlockNavigation: () => set({ navigationLocked: false }, false, 'unlockNavigation'),
    /**
     * Set the IMA (Interactive Media Ad) active state.
     */
    setIMAActive: (isIMAActive) => set({ isIMAActive }, false, 'setIMAActive'),
    /**
     * Increment the videos watched count.
     */
    incrementVideosWatchedCount: () => {
        set((state) => ({
            videosWatchedCount: state.videosWatchedCount + 1,
        }), false, 'incrementVideosWatchedCount');
    },
    /**
     * Register a callback to be called when a certain event occurs.
     * @param event
     * @param fn
     */
    registerInterruptionCallback: (event, fn) => {
        set((state) => ({
            interruptionCallbacks: {
                ...state.interruptionCallbacks,
                [event]: fn,
            },
        }), false, 'registerPlayerInterruptionCallback');
    },
    /**
     * Unregister a callback to be called when a certain event occurs.
     * @param event
     */
    unregisterInterruptionCallback: (event) => {
        set((state) => ({
            interruptionCallbacks: {
                ...state.interruptionCallbacks,
                [event]: undefined,
            },
        }), false, 'unregisterPlayerInterruptionCallback');
    },
    setScrolledToInitialVideo: (scrolledToInitialVideo) => set({ scrolledToInitialVideo }),
});
